import { z } from 'zod'

/**
 * What HoneyBook changed on an event it manages.
 *
 * Mirrors the `EventSyncField` enum in the Prisma schema (`check:enums`).
 * `times` is kept so a row written for a time-only change still loads; date
 * changes currently fold the times into the before and after text.
 */
export const EVENT_SYNC_FIELDS = [
  'name',
  'date',
  'times',
  'guest_count',
  'clients',
  'lifecycle',
  'handed_over',
  'released',
] as const

export const eventSyncFieldSchema = z.enum(EVENT_SYNC_FIELDS)

export type EventSyncField = z.infer<typeof eventSyncFieldSchema>
